import { CoreExerciseFormInput } from '../types/form';
import { Exercise, CreateExerciseInput, ExerciseMediaItem, CreateExerciseMediaInput } from '../types';

function transformMedia(mediaItems: ExerciseMediaItem[]): CreateExerciseMediaInput[] {
  return (
    mediaItems?.map((mediaItem) => {
      const { id, url, type } = mediaItem;
      return {
        _id: id,
        url,
        type,
      };
    }) || []
  );
}
export function transformCoreFormInputToCoreExerciseInput(formInput: CoreExerciseFormInput): CreateExerciseInput {
  const { code, forPractice, explanation, media = [], text, timeLimit } = formInput;
  const { media: explanationMedia = [] } = explanation || {};

  const transformedMedia = transformMedia(media);
  const transformedExplanationMedia = transformMedia(explanationMedia);

  return {
    code,
    text,
    timeLimit: !!timeLimit ? timeLimit : undefined,
    media: transformedMedia,
    forPractice,
    explanation: {
      text: explanation?.text,
      media: transformedExplanationMedia,
    },
  };
}

export function transformCoreExerciseToFormInput(exercise: Exercise): CoreExerciseFormInput {
  const { code, forPractice, explanation, media = [], text, timeLimit } = exercise;

  return {
    code,
    text: text || '',
    timeLimit: timeLimit || undefined,
    media,
    forPractice,
    explanation: {
      text: explanation?.text || '',
      media: exercise.explanation?.media || [],
    },
  };
}
